export const STOPWATCH = {
    start: 'Start',
    stop: 'Stop',
    noActionInProgress: 'There are no Actions “In Progress”',
};
export const DEFAULT_STOPWATCH_STATE = {
    selectedTimeLog: null,
};
